import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { FavouritesAction } from '../../../molecules/favourites-action/js/favourites-action';

const classes = {
	stateLoadingVisible: "state-loading-wrapper--shown",

	addFavouritesBtn: 'js-add-to-favourites',
	checkboxColumn: 'm-table__column-checkbox',
	loadingIndicator: "m-favourite-button__loading-wrapper",
	dynamicContainer: "js-m-favourites-sharing-overview-dynamic-container",
	checkbox: 'js-a-input-checkbox__input',

	tbody: "m-table__body"
};

const popupClasses = {
	popupBox: "js-m-modal-actions",
	textareaBox: "js-m-modal-actions__textarea"
}

@createModule('OverviewShareFavourites')
/**
 * overview-share-favourites module
 */
export class OverviewShareFavourites extends TerrificSpec {
	$ctx: JQuery;
	$loadingIndicator: JQuery;
	$dynamicContainer: JQuery;

	actionViewEndpoint: string;
	loginViewEndpoint: string;

	favorAction: FavouritesAction;

	expired: boolean;
	contentType: string;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$loadingIndicator = this.$ctx.find(`.${classes.loadingIndicator}`);
		this.$dynamicContainer = this.$ctx.find(`.${classes.dynamicContainer}`);

		this.actionViewEndpoint = this.$ctx.data("action-view-endpoint");
		this.loginViewEndpoint = this.$ctx.data("login-view-endpoint");

		this.favorAction = new FavouritesAction();

		this.expired = this.$ctx.data("expired");
		this.contentType = this.$ctx.data("content-type");

		this.changeSelectAll();

		this.$ctx.find(`.${classes.addFavouritesBtn}`).on("click", () => {

			const $selectedEntries = this.$ctx.find(`.${classes.tbody}`).find("input[type=checkbox]:checked");

			if ($selectedEntries.length > 0) {
				this.getActionPartialView();
			}

		});

		if (this.expired) {
			this.favorAction.track("List past timeline", this.contentType);
		} else {
			this.favorAction.track("List within timeline", this.contentType);
		}

		resolve();
	}

	getActionPartialView() {
		this.showLoadingIndicator();

		const ids = this.getSharedEntryIds();
		const actionType = "AddSharedEntry";

		$.ajax({
			type: 'post',
			url: this.actionViewEndpoint,
			dataType: 'html',
			data:
			{
				actionType: actionType,
				ids: ids
			},
			success: (response: any) => {
				if (response.length > 2) {

					this.$dynamicContainer.append(response);
					const $popup = this.$dynamicContainer.children(`.${popupClasses.popupBox}`);
					this.favorAction.displayPopup($popup);
					this.favorAction.rebindCommonViewEvents($popup);
					this.favorAction.bindAddSharedEntrySubmitEvent($popup, this.contentType);
				}

			},
			complete: () => {
				this.hideLoadingIndicator();
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get action-view error, action type: ${actionType}, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	getSharedEntryIds() {

		let $checkedItems = this.$ctx.find(`.${classes.tbody}`).find("input[type=checkbox]:checked");
		const idArr = new Array<string>();
		$checkedItems.each((i: any, e: any) => {
			const value = $(e).attr("id");
			if (typeof (value) != "undefined") {
				idArr.push(value);
			}
		});
		const ids = idArr.join(",");

		return ids;
	}

	showLoadingIndicator() {
		this.$loadingIndicator.addClass(classes.stateLoadingVisible);
	}

	hideLoadingIndicator() {
		this.$loadingIndicator.removeClass(classes.stateLoadingVisible);
	}


	//Select All
	changeSelectAll() {
		const $allSubCheckboxes = $('.m-table__body').find('input[type=checkbox]:not(:disabled)');
		var i = 0;
		$('#SelectAll').on("input propertychange", function (ev: any) {
			const $target: any = $(ev.currentTarget);
			if ($target.is(":checked")) {
				i = $allSubCheckboxes.length;
				$allSubCheckboxes.prop('checked', true);
			} else {
				i = 0;
				$allSubCheckboxes.prop('checked', false);
			}
		});
		$allSubCheckboxes.on("input propertychange", function (ev: any) {
			const $target: any = $(ev.currentTarget);
			if ($target.is(":checked")) {
				i++;
				if (i == $allSubCheckboxes.length) {
					$('#SelectAll').prop('checked', true);
				}
			} else {
				i--;
				$('#SelectAll').prop('checked', false);
			}
		});
	}

	areAllSubChecked($checkboxes: JQuery = $('input[type=checkbox]:not(:disabled)', this.$ctx)) {
		return $checkboxes.toArray().every(this.isElementChecked);
	}

	isElementChecked(element: HTMLInputElement) {
		return element.checked;
	}


	stop() { }

}
